import { useQuery } from '@tanstack/react-query';
import { getUserProfile } from '../api/user';
import { useAuth } from '../providers/AuthProvider';
import { normalizeUser } from '../utils/auth-session';

const QUERY_KEY = ['current-user'];

export const useCurrentUser = () => {
  const { tokens, user, setUser } = useAuth();
  const enabled = Boolean(tokens?.accessToken);

  return useQuery({
    queryKey: [...QUERY_KEY, user?.id ?? 'unknown'],
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    queryFn: async () => {
      const profile = await getUserProfile();
      const normalized = normalizeUser(profile as Record<string, unknown>) ?? null;
      const nextUser = normalized && user?.id === normalized.id
        ? {
          ...normalized,
          requiresConsent: normalized.requiresConsent ?? user.requiresConsent,
          restrictedAccess: normalized.restrictedAccess ?? user.restrictedAccess,
          pendingConsents: normalized.pendingConsents ?? user.pendingConsents,
        }
        : normalized;
      setUser(nextUser);
      return nextUser;
    },
    initialData: user ?? undefined,
    initialDataUpdatedAt: 0,
  });
};

export default useCurrentUser;
